import { styled } from "@mui/material/styles";
import { Paper } from "@mui/material";
import { ThemeProperties } from "../Theme/ThemeProperties";

const PaperHighlight = styled(Paper)({
  backgroundColor: ThemeProperties.white,
  borderRadius: ThemeProperties.borderRadius,
  border: `1px solid ${ThemeProperties.grey}`,
  "&:hover": {
    border: `1px solid ${ThemeProperties.purple}`,
  },
});

const PaperWithBottomRadius = styled(Paper)({
  backgroundColor: ThemeProperties.white,
  border: "1px solid #ececec",
  borderRadius: "0px 0px 12px 12px",
  padding:"10px",
});

export { PaperHighlight, PaperWithBottomRadius };
